import Image from '@app/components/Image'
import ImageLightbox from '@app/components/ImageLightbox'
import { IAttachment } from '@app/models/Attachment'
import { AttachmentType, ImageSize } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import classNames from 'classnames'
import { List } from 'immutable'
import * as React from 'react'

interface IFeedItemAttachmentsProps {
  attachments?: List<IAttachment>
  className?: string
  feedItemId: string
  selectedPhotoId?: string
  setSelectedPhoto: (feedItemId: string, selectedPhotoId: string) => void
}

export default class FeedItemAttachments extends React.PureComponent<IFeedItemAttachmentsProps> {
  public lightboxRef: React.RefObject<ImageLightbox>

  constructor(props: IFeedItemAttachmentsProps) {
    super(props)

    this.lightboxRef = React.createRef<ImageLightbox>()

    bindFunctions(this)
  }

  public render() {
    if (!this.props.attachments || this.props.attachments.size === 0) {
      return null
    }

    const photos = this.props.attachments.filter(
      (a) =>
        a !== undefined &&
        (a.type === AttachmentType.Photo ||
          a.type === AttachmentType.MainPhoto),
    ) as List<IAttachment>
    const files = this.props.attachments.filter(
      (a) =>
        a !== undefined &&
        a.type !== AttachmentType.Photo &&
        a.type !== AttachmentType.MainPhoto,
    ) as List<IAttachment>

    return (
      <div
        className={classNames('feed-item-attachments', this.props.className)}
      >
        {photos.size > 0 && this._renderSelectedPhoto(photos)}
        {photos.size > 0 && this._renderPhotoStrip(photos)}
        {files.size > 0 && this._renderFiles(files)}
      </div>
    )
  }

  private _renderSelectedPhoto(photos: List<IAttachment>) {
    const selectedIndex = photos.findIndex(
      (a) => a !== undefined && a.id === this.props.selectedPhotoId,
    )

    return (
      <div className='feed-item-main-photo-outer-container'>
        <div className='feed-item-main-photo-inner-container'>
          <div className='feed-item-main-photo-wrapper'>
            <Image
              className='feed-item-main-photo'
              image={photos.get(selectedIndex)}
              onClick={() => this._showLightbox(selectedIndex)}
              size={ImageSize.w750}
            />
          </div>
          <ImageLightbox ref={this.lightboxRef} images={photos} />
        </div>
      </div>
    )
  }

  private _renderPhotoStrip(photos: List<IAttachment>) {
    if (photos.size === 1) {
      return null
    }

    const photoItems = photos
      .map((photo, index) => {
        if (!photo) {
          return null
        }

        const thumbnailClasses = classNames('feed-item-photo', {
          active: this.props.selectedPhotoId
            ? photo.id === this.props.selectedPhotoId
            : index === 0,
        })

        return (
          <li
            key={`thumbnail-${photo.id}`}
            className={thumbnailClasses}
            onClick={() =>
              this.props.setSelectedPhoto(this.props.feedItemId, photo.id)
            }
          >
            <img src={photo.getImageUrl(ImageSize.h100w100)} />
          </li>
        )
      })
      .toJS()

    return <ul className='feed-item-photo-strip'>{photoItems}</ul>
  }

  private _renderFiles(files: List<IAttachment>) {
    if (files.size === 0) {
      return null
    }

    const fileLinks = files
      .map((file) => {
        if (!file) {
          return null
        }

        return (
          <li key={`file-${file.id}`}>
            <a href={file.getLocalUrl()} target='_blank' rel='noreferrer'>
              {file.title}
            </a>
          </li>
        )
      })
      .toJS()

    return <ul className='feed-item-files-list'>{fileLinks}</ul>
  }

  private _showLightbox(selectedIndex: number) {
    if (this.lightboxRef.current) {
      this.lightboxRef.current.show(selectedIndex)
    }
  }
}
